import { DateTime } from "luxon";

export const ITEMS_DEFAULT = [
  {
    name: "Mensagem de aniversário",
    active: false,
    key: "BIRTH_DATE",
    description: `O sistema enviará automaticamente uma mensagem de felicitação para o cliente no dia do seu aniversário.
Objetivo: fortalecer o relacionamento, aumentar a fidelização e manter sua ótica presente em momentos especiais.`,
    legend: `@‌NOME: Nome do cliente
@‌DATA: Data do aniversário
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Feliz Aniversário @‌NOME!
Hoje, @‌DATA, é um dia especial, e nós da @NOME_EMPRESA não poderíamos deixar de celebrar com você!
Desejamos muita saúde, felicidade e sucesso.
Conte sempre conosco para enxergar o melhor da vida!
Um grande abraço,
Equipe @NOME_EMPRESA!`,
  },
  {
    name: "Lembrete de vencimento de duplicatas",
    active: false,
    key: "LEMBRETE_DUPLICATA_A_VENCER",
    description: `O sistema enviará automaticamente uma mensagem para o cliente 3 dias antes do vencimento da duplicata. O objetivo é lembrar o cliente sobre a data de pagamento, ajudando a reduzir atrasos e melhorar o fluxo de recebimentos.  EX: Se a duplicata vence na data de ${DateTime.local().plus({ days: 3 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@‌DATA: Data de vencimento da duplicata
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Olá, @‌NOME!
Estamos passando para lembrar que sua duplicata com vencimento em, @‌DATA, está próxima.
Para evitar encargos, recomendamos que o pagamento seja realizado até a data informada.
Caso já tenha efetuado o pagamento, desconsidere esta mensagem.
Qualquer dúvida, estamos à disposição!
Equipe @NOME_EMPRESA`,
  },
  {
    name: "Aviso de vencimento de receitas",
    active: false,
    key: "RECEITA_VENCIDA",
    description: `O sistema enviará automaticamente uma mensagem ao cliente 30 dias antes do vencimento da receita, incentivando a atualização da prescrição e o retorno à ótica. EX: Se a receita vence na data de ${DateTime.local().plus({ days: 30 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Atenção, @‌NOME!
A receita do seu óculos está próxima do vencimento.
Manter sua prescrição atualizada é fundamental para garantir a melhor saúde visual e o máximo conforto no seu dia a dia.
Agende uma nova consulta e continue enxergando o melhor da vida!
Estamos à disposição para ajudar.
Equipe @NOME_EMPRESA`,
  },
  {
    name: "Aviso de vencimento de orçamentos",
    active: false,
    key: "ORCAMENTO_VENCIDO",
    description: `O sistema enviará automaticamente uma mensagem ao cliente 3 dias antes do vencimento do orçamento. O objetivo é lembrar o cliente sobre a validade da proposta e incentivá-lo a concluir a compra. EX: Se o orçamento vence na data de ${DateTime.local().plus({ days: 3 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@‌DATA: Data de vencimento do orçamento
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Lembrete Importante!
Olá, @‌NOME!
O orçamento que elaboramos para você no dia @‌DATA, está próximo do vencimento.
Caso ainda tenha interesse nas condições oferecidas, entre em contato conosco para garantir sua compra!
Estamos à disposição para esclarecer dúvidas ou realizar ajustes, se necessário.
Equipe @NOME_EMPRESA`,
  },
  {
    name: "Clientes que não compram há mais de 1 ano",
    active: false,
    key: "CLIENTES_NAO_COMPRARAM_ULTIMO_ANO",
    description: `O sistema enviará automaticamente uma mensagem para clientes que não realizam compras há mais de 1 ano. O objetivo é reativar o relacionamento, convidando o cliente a retornar à ótica e conhecer novidades e condições especiais. EX: Se o cliente não comprou desde ${DateTime.local().minus({ years: 1 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Sentimos sua falta, @‌NOME!
Notamos que já faz um tempo desde sua última visita à nossa ótica.
Estamos com novidades, lançamentos e condições especiais esperando por você!
Que tal agendar uma visita e conferir tudo o que preparamos para você?
Será um prazer recebê-lo novamente!
Equipe @NOME_EMPRESA`,
  },
  {
    name: "Lembrete de duplicata vencida",
    active: false,
    key: "LEMBRETE_DUPLICATA_VENCIDA",
    description: `O sistema enviará automaticamente uma mensagem para o cliente 3 dia após o vencimento da duplicata, caso o pagamento ainda não tenha sido identificado.
O objetivo é lembrar o cliente de regularizar o pagamento e evitar a geração de juros ou cobranças adicionais. EX: Se a duplicata venceu na data de ${DateTime.local().minus({ days: 3 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@‌DATA: Data de vencimento da duplicata
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Olá, @‌NOME!
Identificamos que sua duplicata com vencimento em @‌DATA ainda consta como pendente em nosso sistema.
Pedimos, por gentileza, que regularize o pagamento o quanto antes para evitar encargos adicionais.
Caso o pagamento já tenha sido realizado, por favor, desconsidere esta mensagem.
Estamos à disposição para qualquer dúvida.
Equipe @NOME_EMPRESA`,
  },
  {
    name: "Enviar mensagem pós-venda",
    active: false,
    key: "POS_VENDA",
    description: `O sistema enviará automaticamente uma mensagem de pós-venda para o cliente 30 dias após a data do pedido de venda. O objetivo é acompanhar a satisfação do cliente com o produto adquirido, reforçar o relacionamento e oferecer suporte caso necessário. EX: Se o pedido foi realizado na data de ${DateTime.local().minus({ days: 30 }).toFormat("dd/MM/yyyy")} irá enviar a mensagem no dia ${DateTime.local().toFormat("dd/MM/yyyy")}.`,
    legend: `@‌NOME: Nome do cliente
@NOME_EMPRESA: Nome da sua empresa`,
    message: `Estamos passando para saber como você está!
Olá, @‌NOME!
Gostaríamos de saber como está sua experiência com seus novos óculos/produto adquirido em nossa ótica.
Sua opinião é muito importante para nós!
Se precisar de algum ajuste, orientação ou tiver qualquer dúvida, estamos à disposição para ajudar.
Conte sempre com a @NOME_EMPRESA!`,
  },
];